export default __webpack_public_path__ + "fonts/icomoon.woff?4849178699a6da372d97f6e757a3ecbc";